"use client";
import type { ReactElement } from "react";
import type { GanttCompactPreviewModel } from "./gantt-render-selectors";
export interface GanttCompactPreviewProps {
    model: GanttCompactPreviewModel;
}
export function GanttCompactPreview({ model, }: GanttCompactPreviewProps): ReactElement {
    return (
      <div data-el="Cmarkdowngantt/CompactPreview/Root" style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            gap: 5,
            padding: "0 4px 26px",
            justifyContent: "center",
        }}>
        {model.tasks.map((task) => (<div key={task.id} style={{
                position: "relative",
                height: 6,
                borderRadius: 2,
                backgroundColor: "rgba(0,0,0,0.35)",
            }}>
            <div style={{
                position: "absolute",
                top: 1,
                bottom: 1,
                left: `${task.startPercent}%`,
                width: `${task.widthPercent}%`,
                borderRadius: 2,
                backgroundImage: `linear-gradient(90deg, ${task.color} 0%, ${task.color}55 100%)`,
            }}/>
          </div>))}
      </div>
    );
}
